import React from "react";
import { TemplateNetworkChooser } from "../../../components/Templates/TemplateNetworkChooser/TemplateNetworkChooser";

interface PortfolioNetworkTemplateTabProps {
  portfolioId: string;
  showArchived: boolean;
}

export const PortfolioNetworkTemplateTab: React.FC<PortfolioNetworkTemplateTabProps> = ({ portfolioId, showArchived }) => {
  return <TemplateNetworkChooser showArchived={showArchived} />;
};